import { ActionContext, ActionTree } from "vuex";
import { StatusCodes } from "http-status-codes";

import FITService from "@/modules/FIT/services/fit.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import notificationService from "@/core/services/notification.service";
import { IFITState } from "@/modules/FIT/vuex/state";
import { StoreState } from "@/store/type";
import { FITBookingPayload, FITSearchPayload } from "../constants";
import { NOTIFICATION_MESSAGES } from "@/core/constants/notificationMessages";

const actions: ActionTree<IFITState, StoreState> = {
  // ****** Fetch FIT Hotels ******
  async getFITHotelDetails(
    context: ActionContext<IFITState, StoreState>,
    params: FITSearchPayload,
  ) {
    try {
      context.commit("fetchedHotelData", null);
      context.commit("isFetchingFitHotels", true);
      const fITService = new FITService();
      const response = await fITService.fetchFitHotel(params);
      if (
        response.success &&
        response.status === StatusCodes.OK &&
        response.data
      ) {
        context.commit("fetchedHotelData", response.data.data);
      } else {
        throw response;
      }
    } catch (error: any) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description =
        error?.message || NOTIFICATION_MESSAGES.DEFAULT;
      notificationService.triggerNotification();
    } finally {
      context.commit("isFetchingFitHotels", false);
    }
  },
  async confirmFITHotels(
    context: ActionContext<IFITState, StoreState>,
    params: FITBookingPayload,
  ): Promise<boolean> {
    try {
      context.commit("isSendingFITEmail", true);

      const fITService = new FITService();
      const response = await fITService.fitSendEmailRequest(params);

      if (response.success) {
        notificationService.type = NOTIFICATION_TYPES.SUCCESS;
        notificationService.description = response?.message || "";
        notificationService.triggerNotification();

        return true;
      } else {
        throw response;
      }
    } catch (error: any) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description =
        error?.message || NOTIFICATION_MESSAGES.DEFAULT;
      notificationService.triggerNotification();

      return false;
    } finally {
      context.commit("isSendingFITEmail", false);
    }
  },
};

export default actions;
